import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import Brand from "@/components/Brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, redirect_base: window.location.origin });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Failed");
    } finally { setLoading(false); }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8 bg-background">
        <div className="max-w-sm w-full text-center space-y-4" data-testid="forgot-sent">
          <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
            <EnvelopeSimple size={28} weight="duotone" className="text-primary" />
          </div>
          <h2 className="font-heading text-2xl font-bold tracking-tight">Check your email</h2>
          <p className="text-sm text-muted-foreground">
            If an account exists for <span className="font-medium text-foreground">{email}</span>, we've sent a password reset link.
            It expires in 1 hour.
          </p>
          <Link to="/login"><Button className="rounded-full">Back to sign in</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="forgot-form">
        <Brand />
        <Link to="/login" className="inline-flex items-center gap-2 text-xs text-muted-foreground hover:text-foreground">
          <ArrowLeft size={14} /> Back to sign in
        </Link>
        <div>
          <div className="overline text-muted-foreground mb-2">Recovery</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight">Forgot password?</h2>
          <p className="text-sm text-muted-foreground mt-1">Enter your email and we'll send a reset link.</p>
        </div>
        <div>
          <Label className="text-xs">EMAIL</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            autoComplete="off" placeholder="you@company.com" className="mt-1.5" data-testid="forgot-email-input" />
        </div>
        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="forgot-submit-button">
          {loading ? "Sending…" : "Send reset link"}
        </Button>
      </form>
    </div>
  );
}
